import { useCallback, useState } from 'react'

import axios from 'axios'

import { subdelegatedClient } from 'adapters/http'
import { SubdelegatedErrorResponse, SubdelegatedRegistrationPayload } from 'models/interface/subdelegated'

export type SubmitStatus = 'idle' | 'submitting' | 'success' | 'error'

const DEFAULT_SUBMIT_ERROR_MESSAGE =
  'Não foi possível enviar seu cadastro. Tente novamente ou entre em contato com o seu consultor.'

type UseSubmitRegistrationResult = {
  status: SubmitStatus
  errorMessage: string
  submit: (payload: SubdelegatedRegistrationPayload) => Promise<SubmitStatus>
}

export const useSubmitRegistration = (code: string): UseSubmitRegistrationResult => {
  const [status, setStatus] = useState<SubmitStatus>('idle')
  const [errorMessage, setErrorMessage] = useState(DEFAULT_SUBMIT_ERROR_MESSAGE)

  const submit = useCallback(
    async (payload: SubdelegatedRegistrationPayload): Promise<SubmitStatus> => {
      setStatus('submitting')

      try {
        await subdelegatedClient.submitRegistration(code, payload)
        setStatus('success')
        return 'success'
      } catch (error) {
        const details = axios.isAxiosError<SubdelegatedErrorResponse>(error) ? error.response?.data?.details : undefined
        setErrorMessage(details || DEFAULT_SUBMIT_ERROR_MESSAGE)
        setStatus('error')
        return 'error'
      }
    },
    [code]
  )

  return { status, errorMessage, submit }
}
